@file:kotlin.js.JsExport
package com.narbase.car.dto.domain.appSettings

import com.narbase.letsgo.router.EndPoint

object GetSupportWhatsappNumberEndpoint
    : EndPoint<GetSupportWhatsappNumberEndpoint.Request, GetSupportWhatsappNumberEndpoint.Response>() {

    class Request
    class Response(
        val callingCode: String,
        val localPhone: String
    )
}